import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core"


const WarningIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <svg version="1.1" id="Layer_1" x="0px" y="0px"
                 viewBox="0 0 512 512">
                <path id="Path_684" fill="#FF8A7A" d="M255.992,399.694c-11.023,0-19.959-8.936-19.959-19.959
	c0-11.023,8.936-19.959,19.959-19.959l0,0c11.023,0,19.959,8.936,19.959,19.959C275.951,390.758,267.015,399.694,255.992,399.694z
	 M275.941,309.884V163.198c0-11.023-8.936-19.959-19.959-19.959c-11.023,0-19.959,8.936-19.959,19.959v146.685
	c0,11.023,8.936,19.959,19.959,19.959C267.005,329.842,275.941,320.906,275.941,309.884z M497.014,442.24
	c15.47-22.626,18.69-51.458,8.594-76.939c-4.084-10.234-15.691-15.219-25.924-11.135c-10.234,4.084-15.219,15.691-11.135,25.924l0,0
	c5.177,13.19,3.466,28.09-4.565,39.764c-7.886,11.796-21.183,18.827-35.372,18.702H83.334
	c-23.677-0.013-42.861-19.218-42.849-42.895c0.004-7.954,2.221-15.75,6.403-22.516L219.527,93.683
	c12.388-20.128,38.748-26.403,58.876-14.016c5.704,3.511,10.505,8.311,14.016,14.016l127.656,206.686
	c5.79,9.376,18.083,12.283,27.459,6.493c9.376-5.79,12.283-18.083,6.493-27.459l0,0L326.351,72.755
	c-23.999-38.869-74.964-50.924-113.833-26.925c-10.947,6.759-20.166,15.978-26.925,26.925L12.955,352.218
	c-24.027,38.902-11.969,89.915,26.933,113.943c13.057,8.065,28.099,12.341,43.446,12.352h345.277
	c27.444,0.215,53.15-13.407,68.384-36.235L497.014,442.24z"/>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
            </svg>
        </SvgIcon>
    )
};

export default WarningIcon;